export default __webpack_public_path__ + "static/media/check-5.56b82db8.svg";